import React from 'react'
import { SubPageContainer } from '../App/components/SubPageContainer'

// Tranlations
import t from '../../translations'

export default function What(props) {
  return <SubPageContainer {...props}>
    <section>
      <h1>
        <span>{t[props.lang]['Welcome!']}</span>
      </h1>
      <h2>
        {t[props.lang]['This is a personal website.']}
      </h2>
      <p>
        {t[props.lang][`So I'm developing this site slowly, in my free time...`]}
      </p>

      <p>
        {t[props.lang][`Site objectives`]}
      </p>
    </section>
  </SubPageContainer>
}